<template>
  <div class="mobile-survey" v-show="mobileShow">
    <div class="mobile-survey-box">
      <div class="mobile-title">{{ title }}</div>
      <p class="mobile-desc" v-html="desc" v-if="desc"></p>
      <div v-if="videoPath" class="mobile-video">
        <video :src="videoPath" controls style="width:100%;max-height:200px"></video>
      </div>
      <div class="mobile-list-box">
        <div class="mobile-list" v-for="(item, index) in subjectList" :key="index">
          <!-- 单选题 -->
          <div class="subject-box-list" v-show="getType(item)==1">
            <div class="subject-list-title">
              <div class="subject-title-left">
                <span v-show="item.isRequired">*</span>{{ index + 1 }}、{{ item.subjectTitle }}
              </div>
            </div>
            <el-radio-group class="subject-group" v-model="item.inputText" style="line-height: 28px" disabled>
              <div v-for="(items, index1) in item.selectItems">
                <el-radio
                  class="subject-radio mb10"
                  :key="index1"
                  :label="items.text"
                >
                </el-radio>
                <div style="margin-left: 20px;" v-if="items.isAdd">
                  <el-radio-group
                   v-if="items.subjectItem.subjectType=='单选题'&&(items.subjectItem.subjectItemType=='1'||items.subjectItem.subjectItemType=='4')&&items.subjectItem.interactType=='1'" 
                   class="subject-group" v-model="items.subjectItem.inputText" 
                   style="line-height: 28px" disabled>
                    <el-radio
                      class="subject-radio mb10"
                      v-for="(obj, index2) in items.subjectItem.selectItems"
                      :key="index2"
                      :label="obj.text"
                    >
                    </el-radio>
                  </el-radio-group>
                  <el-checkbox-group
                   v-else-if="items.subjectItem.subjectType == '多选题'&&(items.subjectItem.subjectItemType=='1'||items.subjectItem.subjectItemType=='4')&&items.subjectItem.interactType=='1'"
                   disabled class="subject-group" v-model="items.subjectItem.valueSelect" style="line-height: 28px">
                    <el-checkbox
                      class="subject-radio"
                      v-for="(obj, index2) in items.subjectItem.selectItems"
                      :key="index2"
                      :label="obj.text"
                    ></el-checkbox>
                  </el-checkbox-group>
                  <el-input 
                    v-else-if="items.subjectItem.subjectType=='单行填空题'"
                    class="w100f pb10" 
                    disabled 
                    type="input" 
                    :placeholder="items.subjectItem.cueWords" 
                    v-model="items.subjectItem.inputText" />
                  <el-input 
                    disabled 
                    v-else-if="items.subjectItem.subjectType=='多行填空题'"
                    class="w100f pb10" 
                    type="textarea" 
                    :placeholder="items.subjectItem.cueWords" 
                    :rows="3" 
                    v-model="items.subjectItem.inputText" />
                    <el-select
                     v-else
                     disabled class="w100f pb10" v-model="value" placeholder="请选择">
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                </div>
                  
              </div>
              
            </el-radio-group>
          </div>
          <!-- 多选题 -->
          <div class="subject-box-list" v-show="getType(item)==2">
            <div class="subject-list-title">
              <div class="subject-title-left">
                <span v-show="item.isRequired">*</span>{{ index + 1 }}、{{ item.subjectTitle }}
              </div>
            </div>
            
            <el-checkbox-group disabled class="subject-group" v-model="item.valueSelect" style="line-height: 28px">
              <div v-for="(items, index1) in item.selectItems">
                <el-checkbox
                  class="subject-radio"
                  :key="index1"
                  :label="items.text"
                ></el-checkbox>
                <div style="margin-left: 20px;" v-if="items.isAdd">
                  <el-radio-group
                   v-if="items.subjectItem.subjectType=='单选题'&&(items.subjectItem.subjectItemType=='1'||items.subjectItem.subjectItemType=='4')&&items.subjectItem.interactType=='1'" 
                   class="subject-group" v-model="items.subjectItem.inputText" 
                   style="line-height: 28px" disabled>
                    <el-radio
                      class="subject-radio mb10"
                      v-for="(obj, index2) in items.subjectItem.selectItems"
                      :key="index2"
                      :label="obj.text"
                    >
                    </el-radio>
                  </el-radio-group>
                  <el-checkbox-group
                   v-else-if="items.subjectItem.subjectType == '多选题'&&(items.subjectItem.subjectItemType=='1'||items.subjectItem.subjectItemType=='4')&&items.subjectItem.interactType=='1'"
                   disabled class="subject-group" v-model="items.subjectItem.valueSelect" style="line-height: 28px">
                    <el-checkbox
                      class="subject-radio"
                      v-for="(obj, index2) in items.subjectItem.selectItems"
                      :key="index2"
                      :label="obj.text"
                    ></el-checkbox>
                  </el-checkbox-group>
                  <el-input 
                    v-else-if="items.subjectItem.subjectType=='单行填空题'"
                    class="w100f pb10" 
                    disabled 
                    type="input" 
                    :placeholder="items.subjectItem.cueWords" 
                    v-model="items.subjectItem.inputText" />
                  <el-input 
                    disabled 
                    v-else-if="items.subjectItem.subjectType=='多行填空题'"
                    class="w100f pb10" 
                    type="textarea" 
                    :placeholder="items.subjectItem.cueWords" 
                    :rows="3" 
                    v-model="items.subjectItem.inputText" />
                  <el-select
                    v-else
                    disabled class="w100f pb10" v-model="value" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </div>
              </div>
            </el-checkbox-group>
            
          </div>
          <!-- 单行填空题 -->
          <div class="subject-box-list pb10" v-show="getType(item)==3">
            <div class="subject-list-title">
              <div class="subject-title-left">
                <span v-show="item.isRequired">*</span>{{ index + 1 }}、{{ item.subjectTitle }}
              </div>
            </div>
            <el-input class="w100f" disabled type="input" placeholder="请输入" v-model="item.inputText" />
          </div>
          <!-- 多行填空题 -->
          <div class="subject-box-list pb10" v-show="getType(item)==4">
            <div class="subject-list-title">
              <div class="subject-title-left">
                <span v-show="item.isRequired">*</span>{{ index + 1 }}、{{ item.subjectTitle }}
              </div>
            </div>
            <el-input disabled class="w100f" type="textarea" placeholder="请输入" :rows="3" v-model="item.inputText" />
          </div>
          <!-- 选择区域 -->
          <div class="subject-box-list pb10" v-show="getType(item)==5">
            <div class="subject-list-title">
              <div class="subject-title-left">
                <span v-show="item.isRequired">*</span>{{ index + 1 }}、{{ item.subjectTitle }}
              </div>
            </div>
            <el-select disabled class="w100f" v-model="value" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>
          <!-- 调研对象 -->
          <div class="subject-box-list" v-show="getType(item)==6">
            <div class="subject-list-title">
              <div class="subject-title-left">
                <span v-show="item.isRequired">*</span>{{ index + 1 }}、{{ item.subjectTitle }}
              </div>
            </div>
            <el-radio-group class="subject-group" v-model="item.inputText" style="line-height: 28px" disabled>
              <el-radio
                class="subject-radio mb10"
                v-for="(items, index1) in item.selectItems"
                :key="index1"
                :label="items.text"
              ></el-radio>
            </el-radio-group>
          </div>
          <!-- 客户名称 -->
          <div class="subject-box-list pb10" v-show="getType(item)==7">
            <div class="subject-list-title">
              <div class="subject-title-left">
                <span v-show="item.isRequired">*</span>{{ index + 1 }}、{{ item.subjectTitle }}
              </div>
            </div>
            <el-select disabled class="w100f" v-model="value" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>
          <!-- 上传照片 -->
          <div class="subject-box-list pb10" v-show="getType(item)==8">
            <div class="subject-list-title">
              <div class="subject-title-left">
                <span v-show="item.isRequired">*</span>{{ index + 1 }}、{{ item.subjectTitle }}
              </div>
            </div>
            <div class="avatar-uploader">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </div>
          </div>
          <!-- 新题型-->
          <div
            class="subject-box-list pb10"
            v-show="getType(item)==0">
            <div class="subject-list-title">
              <div class="subject-title-left">
                <span v-show="item.isRequired == 'Y'">*</span>{{ index + 1 }}、
                <span style="color:#333" v-show="item.subjectType !== '填写日期'">【{{ item.subjectType }}】</span>
                {{item.subjectTitle}}
              </div>
            </div>
            <!-- <el-input class="ml20 w49f" disabled type="input" placeholder="请输入" v-model="item.inputText" /> -->
            
            <el-select disabled class="w100f" v-model="value" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>
          
        </div>
      </div>

      <div class="close-btn" @click="pageClose()">关闭</div>
    </div>
  </div>
</template>
<script>
import {getQuestionType} from '@/uilt/questionType'
export default {
  props: {
    subjectList: {
      type: Array,
      default: [],
    },
    title: {
      type: String,
      default: '-',
    },
    desc: {
      type: String,
      default: '',
    },
    videoUrl: {
      type: String,
      default: '',
    },
  },
  computed: {
    videoPath() {
      if (!this.videoUrl) return ''
      try {
        const parsed = JSON.parse(this.videoUrl)
        return parsed.path || ''
      } catch {
        return this.videoUrl
      }
    },
  },
  data() {
    return {
      mobileShow: false,
      options: [],
      value: '',
    };
  },
  methods: {
    pageClose() {
      this.mobileShow = false;
      this.$emit('pageClose', this.mobileShow);
    },
    getType(item) { 
      // 新加题型默认选择框，如需特殊处理需要新增case
      return getQuestionType(item)
    }, 
  },
};
</script>
<style scoped>
.mobile-survey {
  padding-top: 30px;
  /* position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  background: #e9eef3; */
}
.mobile-survey-box {
  position: relative;
  /* width: 536px; */
  width: 375px;
  min-height: 667px;
  padding: 30px;
  margin-bottom: 50px;
  background: #fff;
  margin-left: calc(50% - 187px);
  margin-right: calc(50% - 187px);
  /* margin: 0 25%; */
  /* margin-left: calc(50% - 268px);
  margin-right: calc(50% - 268px); */
  /* transform:scale(0.7); */
  box-sizing: border-box;
}
.mobile-video {
  margin-bottom: 12px;
  text-align: center;
}
.mobile-video video {
  border-radius: 4px;
  background: #000;
}
.mobile-title {
  color: #649fa4;
  font-size: 16px;
  text-align: center;
}
.mobile-desc {
  /* font-size: 14px;
  color: #7e7e7e;
  text-align: left; */
  padding-bottom: 10px;
  border-bottom: 1px solid #e9eef3;
  font-size: initial;
  text-align: initial;
  line-height: inherit;
}

.mobile-list {
  font-size: 16px !important;
}
.mobile-list-box{
  margin-bottom: 50px;
}
/* .mobile-list:last-child {
  margin-bottom: 40px;
} */
.subject-box-list {
  text-align: left;
  padding: 0;
  /* border-bottom: 1px solid #e3e3e3; */
}

.subject-list-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.subject-group {
  display: flex;
  flex-flow: column;
  /* padding-left: 10px; */
}
.subject-radio {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.close-btn {
  position: absolute;
  bottom: 24px;
  width: 315px;
  height: 44px;
  line-height: 44px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  background: #649fa4;
}
.subject-title-left span {
  color: red;
}
/deep/.el-checkbox__label{
  white-space: pre-wrap;
  word-break: break-all;
}
/deep/.el-radio__label{
  white-space: pre-wrap;
  word-break: break-all;
  line-height: 22px;
}
 .avatar-uploader  {
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 110px;
  }
 
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 110px;
    height: 110px;
    line-height: 110px;
    text-align: center;
  }
</style>